import React from 'react';
import { useModalStore } from '@/store';
import ChatInputBanner, { ChatInputBannerAction } from '@/components/ChatInput/ChatInputBanner';
import useTranslation from '@/hooks/useTranslation';

function ChatInputGhostBanner({ level, isCloseable = false, isDetached = false }) {
  const { openModal } = useModalStore(state => state.actions);
  const { t } = useTranslation();

  return (
    <ChatInputBanner color="tertiary" level={level} isCloseable={isCloseable} isDetached={isDetached}
      actions={<ChatInputBannerAction onPress={() => openModal('GhostSignupModal')}>{t('chatInput.ghost.connectEmailLink')}</ChatInputBannerAction>}>
      {t('chatInput.ghost.connectEmailMessage')}
    </ChatInputBanner>
  );
} 

export default React.memo(ChatInputGhostBanner);